document.addEventListener("DOMContentLoaded", () => {
  const sliderContainer = document.querySelector(".tetra_slider-track");
  const buttons = document.querySelectorAll(".desktop_city_desc .city-item");
  const buttonsMobile = document.querySelectorAll(".mobile_city_desc .city-item");
  const allSlides = [];
  document.querySelectorAll(".tetra_slider-track .tetra_slide").forEach(slide => {
    console.log(slide.dataset.city);
    const city = slide.dataset.city;
    if (city) {
      allSlides.push({
        city,
        html: slide.outerHTML
      });
    }
  });
  sliderContainer.innerHTML = "";
  function showSlidesForCity(city) {
  const slider = document.querySelector('.tetra_image-slider');
  const track = slider.querySelector('.tetra_slider-track');
  const pagination = slider.querySelector('.tetra_pagination');
  track.innerHTML = '';
  pagination.innerHTML = '';console.log('allSlides' , allSlides)
  const filtered = allSlides.filter(slide => slide.city === city);
  filtered.forEach(slide => {
    track.insertAdjacentHTML("beforeend", slide.html);
  });
  filtered.forEach((_, i) => {
    const dot = document.createElement('span');
    dot.className = `tetra_dot tetra_dot--${i + 1} ${i === 0 ? 'active' : ''}`;
    pagination.appendChild(dot);
  });
  initializeTetraSlider(slider);
}
  buttons.forEach((button, index) => {
    button.addEventListener("click", () => {
      const selectedCity = button.dataset.city;
      if (!selectedCity) return;
      showSlidesForCity(selectedCity);
      buttons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");
      buttonsMobile.forEach((mobileButton, mobileIndex) => {
        if (mobileIndex === index) {
          mobileButton.classList.add("active");
        } else {
          mobileButton.classList.remove("active");
        }
      });
    });
  });
  buttonsMobile.forEach((mobileButton, index) => {
    mobileButton.addEventListener("click", () => {
      const selectedCity = mobileButton.dataset.city;
      if (!selectedCity) return;
      showSlidesForCity(selectedCity);
      buttonsMobile.forEach(btn => btn.classList.remove("active"));
      mobileButton.classList.add("active");
      buttons.forEach((desktopButton, desktopIndex) => {
        if (desktopIndex === index) {
          desktopButton.classList.add("active");
        } else {
          desktopButton.classList.remove("active");
        }
      });
    });
  });
  if (buttons.length > 0) {
    const firstButton = buttons[0];
    const firstCity = firstButton.dataset.city;
    if (firstCity) {
      firstButton.classList.add("active");
      showSlidesForCity(firstCity);
      buttonsMobile[0].classList.add("active");
    }
  }
  const links = document.querySelectorAll('.page-navigation__link');
  links.forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    
    const targetId = this.getAttribute('data-target');
    let targetElement = document.querySelector(`.desktop_city_desc .city-item#${targetId}`);
    
    if (window.innerWidth <= 768) {
      targetElement = document.querySelector(`.mobile_city_desc .city-item[data-city="${targetId}"]`);
    }
    
    if (targetElement) {
      const offset = 80;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
      
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      const duration = Math.min(Math.abs(distance) / 2, 1000);
      let startTime = null;

      function smoothScroll(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        
        const easeInOut = progress < 0.5 
          ? 2 * progress * progress 
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        
        window.scrollTo(0, startPosition + distance * easeInOut);
        
        if (progress < 1) {
          requestAnimationFrame(smoothScroll);
        } else {
          targetElement.click();
        }
      }
      requestAnimationFrame(smoothScroll);
    }
  });
});
});
function initializeTetraSlider(slider) {
  const track = slider.querySelector('.tetra_slider-track');
  const slides = slider.querySelectorAll('.tetra_slide');
  const dots = slider.querySelectorAll('.tetra_dot');
  const leftBtn = slider.querySelector('.tetra_arrow.left');
  const rightBtn = slider.querySelector('.tetra_arrow.right');
  let index = 0;
  let isTransitioning = false;
  if (!slides.length) return;
  const totalSlides = slides.length;
  const updateSlider = (animate = true) => {
    const offset = -index * 100;
    track.style.transition = animate ? 'transform 0.4s ease' : 'none';
    track.style.transform = `translateX(${offset}%)`;
    dots.forEach((dot, i) => dot.classList.toggle('active', i === index % totalSlides));
  };
  const nextSlide = () => {
    if (isTransitioning) return;
    index++;
    updateSlider();
    if (index === totalSlides) {
      isTransitioning = true;
      setTimeout(() => {
        index = 0;
        updateSlider(false);
        isTransitioning = false;
      }, 400);
    }
  };
  const prevSlide = () => {
    if (isTransitioning) return;
    if (index === 0) {
      track.style.transition = 'none';
      index = totalSlides;
      track.style.transform = `translateX(${-index * 100}%)`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          index = totalSlides - 1;
          updateSlider();
        });
      });
    } else {
      index--;
      updateSlider();
    }
  };
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      if (isTransitioning || index === i) return;
      index = i;
      updateSlider();
    });
  });
  rightBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    nextSlide();
  });
  leftBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    prevSlide();
  });
  let startX = 0;
  let isDragging = false;
  slider.addEventListener('pointerdown', (e) => {
    startX = e.clientX;
    isDragging = true;
  });
  slider.addEventListener('pointerup', (e) => {
    if (!isDragging) return;
    const diff = e.clientX - startX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? prevSlide() : nextSlide();
    }
    isDragging = false;
  });
  slider.addEventListener('pointerleave', () => {
    isDragging = false;
  });
  updateSlider(false);
}